export enum ImpersonateMenuPage {
  User,
  Impersonate,
}

export enum ImpersonateMenuAction {
  Close,
  Transition,
}

export interface ImpersonateMenuComponent {
  onAction(action: ImpersonateMenuAction.Close): void;
  onAction(action: ImpersonateMenuAction.Transition, page: ImpersonateMenuPage): void;
  width: number;
}
